import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


// ✅ Estados "normales" o válidos:
// Código	Descripción	Clase CSS sugerida	Icono
// 1	NO validado	badge - estado - warning(sin icono)
// 2	Pendiente	badge - estado - info(sin icono)
// 3	Cargado	badge - estado - success(sin icono)
// 4	Eliminado	badge - estado - danger(negrita)

// ⚠️ Estados de error o advertencia detectados automáticamente:
// Código	Descripción	Clase CSS sugerida	Icono FontAwesome
// 71	Sin stock suficiente	badge - estado - danger	fa - triangle - exclamation
// 81	Artículo NO existe	badge - estado - danger	fa - box - open
// 82	Sin stock suficiente	badge - estado - danger	fa - triangle - exclamation
// 83	Sin detalle	badge - estado - danger	fa - list
// 84	Sin Nº pedido cliente	badge - estado - warning	fa - user - xmark
// 85	Cliente desconocido	badge - estado - warning	fa - user - slash
// 86	Pedido duplicado	badge - estado - info	fa - clone


@Pipe({
  name: 'pedidoExternoEstado'
})
export class PedidoExternoEstadoPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: unknown): SafeHtml {
    let label = '';
    let cssClass = '';
    let icon = '';
    let strong = false;

    switch (Number(value)) {
      case 1:
        label = 'NO validado';
        cssClass = 'badge-estado-warning';
        break;
      case 2:
        label = 'Pendiente';
        cssClass = 'badge-estado-info';
        break;
      case 3:
        label = 'Cargado';
        cssClass = 'badge-estado-success';
        break;
      case 4:
        label = 'Eliminado';
        cssClass = 'badge-estado-danger';
        strong = true;
        break;
      case 71:
        label = 'Sin stock suficiente';
        cssClass = 'badge-estado-warning';
        icon = '<i class="fa-solid fa-circle-info me-1"></i>';
        break;
      case 81:
        label = 'Artículos NO existen';
        cssClass = 'badge-estado-orange';
        icon = '<i class="fa-solid fa-triangle-exclamation me-1"></i>';
        break;
      case 82:
        label = 'Sin stock suficiente';
        cssClass = 'badge-estado-orange';
        icon = '<i class="fa-solid fa-triangle-exclamation me-1"></i>';
        break;
      case 83:
        label = 'Sin líneas de detalle';
        cssClass = 'badge-estado-danger';
        icon = '<i class="fa-solid fa-triangle-exclamation me-1"></i>';
        strong = true;
        break;
      case 84:
        label = 'Sin Nº pedido cliente';
        cssClass = 'badge-estado-danger';
        icon = '<i class="fa-solid fa-triangle-exclamation me-1"></i>';
        strong = true;
        break;
      case 85:
        label = 'Cliente desconocido';
        cssClass = 'badge-estado-danger';
        icon = '<i class="fa-solid fa-triangle-exclamation me-1"></i>';
        strong = true;
        break;
      case 86:
        label = 'Pedido duplicado';
        cssClass = 'badge-estado-danger';
        icon = '<i class="fa-solid fa-triangle-exclamation me-1"></i>';
        strong = true;
        break;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(String(value));
    }

    const text = strong ? `<strong>${label}</strong>` : label;
    const html = `<span class="badge ${cssClass}">${icon} ${text}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

}
